import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import SectionTitle from '@/components/base/SectionTitle';

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 - 非麻瓜漫画';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '非麻瓜漫画品牌介绍、口碑评价与联系方式。了解非麻瓜漫画的平台理念，海量免费韩漫，下拉式阅读，每日更新韩国漫画全集。');
    }
    return () => {
      document.title = '非麻瓜漫画-免费韩漫在线阅读网站_最新韩国漫画下拉式观看';
    };
  }, []);

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="min-h-screen pt-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          {/* Brand Introduction */}
          <section className="py-10">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading text-center mb-4">
                关于非麻瓜漫画
              </h1>
              <p className="text-center text-foreground-600 mb-10 max-w-2xl mx-auto">
                非麻瓜漫画是一个致力于为华语读者提供免费韩国漫画在线阅读的平台，我们相信每一位漫画爱好者都应该能够无障碍地享受韩漫的魅力。
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center hover:border-primary-200 transition-all duration-300">
                  <span className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-4">
                    <i className="ri-book-open-line text-2xl"></i>
                  </span>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2">海量资源</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    非麻瓜漫画收录数千部<strong>韩国漫画</strong>资源，涵盖恋爱、奇幻、动作、剧情等多种类型，每日持续更新<strong>最新韩国漫画全集</strong>。
                  </p>
                </div>

                <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center hover:border-primary-200 transition-all duration-300">
                  <span className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-4">
                    <i className="ri-smartphone-line text-2xl"></i>
                  </span>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2">极致体验</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    支持<strong>下拉式阅读</strong>，完美适配桌面和移动端，无需翻页即可流畅阅读<strong>韩漫在线</strong>观看。
                  </p>
                </div>

                <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center hover:border-primary-200 transition-all duration-300">
                  <span className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 mb-4">
                    <i className="ri-shield-check-line text-2xl"></i>
                  </span>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2">完全免费</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    无需注册，无需付费，<strong>非麻瓜漫画</strong>所有内容永久免费开放。<strong>韩漫免费观看</strong>，是我们不变的承诺。
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Reputation / Testimonials */}
          <section className="py-10 bg-background-100">
            <div className="max-w-4xl mx-auto px-4">
              <SectionTitle title="读者口碑" subtitle="来自漫画爱好者的真实评价" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {[
                  { name: '小雨', text: '非麻瓜漫画真的是我发现的宝藏韩漫网站！资源超全，更新还快，最重要的是完全免费，下拉式阅读体验太舒服了。', rating: 5 },
                  { name: '星辰大海', text: '一直在找可以免费看韩漫的平台，非麻瓜漫画界面简洁，分类清晰，漫画质量很高。强烈推荐给喜欢韩国漫画的朋友！', rating: 5 },
                  { name: '漫迷小白', text: '在非麻瓜漫画看韩漫已经半年了，资源更新速度很快，画质也很清晰，下拉式漫画阅读体验很棒，已经推荐给了身边的漫友。', rating: 5 },
                  { name: '月光族的日常', text: '不用花钱就能看这么多高质量韩漫，非麻瓜漫画真的太良心了！分类很全，不管是恋爱还是奇幻类型都有很多选择。', rating: 4 },
                ].map((review, idx) => (
                  <div key={idx} className="bg-background-50 rounded-lg p-5 border border-background-200/70">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 w-4 h-4 flex items-center justify-center text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-3">&ldquo;{review.text}&rdquo;</p>
                    <p className="text-xs text-foreground-500 font-medium">—— {review.name}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Contact Form */}
          <section className="py-10">
            <div className="max-w-2xl mx-auto">
              <SectionTitle title="联系我们" subtitle="有任何问题或建议？欢迎给我们留言" />
              <ContactForm />
            </div>
          </section>

          {/* Brand Info */}
          <section className="py-8 border-t border-background-200/70">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="text-xl font-bold text-foreground-950 font-heading mb-3">非麻瓜漫画</h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                非麻瓜漫画是一个专注于提供<strong>免费韩漫</strong>在线阅读的<strong>韩漫网站</strong>，致力于为华语地区的漫画爱好者提供优质的<strong>韩国漫画免费读</strong>体验。
                支持<strong>下拉式漫画</strong>阅读方式，每日更新<strong>韩国漫画全集</strong>，让每一位读者都能畅享<strong>韩漫在线</strong>阅读的乐趣。
              </p>
            </div>
          </section>
        </div>
      </main>

      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "关于非麻瓜漫画",
          "description": "非麻瓜漫画是一个专注于提供免费韩漫在线阅读的平台，致力于为华语地区的漫画爱好者提供优质的韩国漫画阅读体验。",
          "url": "https://feimagua.com/about",
          "inLanguage": "zh-Hans",
          "about": {
            "@type": "Organization",
            "name": "非麻瓜漫画",
            "url": "https://feimagua.com",
            "description": "非麻瓜漫画提供海量免费韩漫在线观看，支持下拉式阅读体验，每日更新最新韩国漫画全集。"
          }
        })
      }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://feimagua.com" },
            { "@type": "ListItem", "position": 2, "name": "关于我们", "item": "https://feimagua.com/about" }
          ]
        })
      }} />
    </>
  );
}

function ContactForm() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      alert('感谢您的留言，我们会尽快回复！');
      form.reset();
      return;
    }

    const formData = new FormData(form);
    try {
      const response = await fetch('https://readdy.ai/api/form/d9pev6pn2trhb35gve7g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        alert('感谢您的留言，我们会尽快回复！');
        form.reset();
      } else {
        const errMsg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
        alert(errMsg);
      }
    } catch {
      alert('网络错误，请稍后重试');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-background-50 border border-background-200/70 rounded-lg p-6 space-y-4" data-readdy-form>
      <div>
        <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1">姓名</label>
        <input
          id="contact-name"
          name="name"
          type="text"
          required
          className="w-full px-3 py-2.5 text-sm border border-background-200/70 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-300 transition-colors"
          placeholder="请输入您的姓名"
        />
      </div>
      <div>
        <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1">邮箱</label>
        <input
          id="contact-email"
          name="email"
          type="email"
          required
          className="w-full px-3 py-2.5 text-sm border border-background-200/70 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-300 transition-colors"
          placeholder="请输入您的邮箱"
        />
      </div>
      <div>
        <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800 mb-1">留言内容</label>
        <textarea
          id="contact-message"
          name="message"
          required
          maxLength={500}
          rows={4}
          className="w-full px-3 py-2.5 text-sm border border-background-200/70 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-300 transition-colors resize-none"
          placeholder="请输入您的留言内容（最多500字）"
        ></textarea>
      </div>

      <input name="website_alt" type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />

      <button
        type="submit"
        className="w-full py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        提交留言
      </button>
    </form>
  );
}